import {Box, Tab, Tabs} from '@mui/material';
import {Route, Routes} from 'react-router-dom';
import {useLocation, useNavigate} from 'react-router';
import Items from '../items/Items';
import Packagings from "./Packagings";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";

function ItemsMain() {
    const {t} = useAppTranslation();
    const history = useNavigate();
    const location = useLocation();

    const handleChange = (event: any, newValue: string) => {
        history(newValue);
    };

    return (
        <Box>
            <Box sx={{mb: {xs: 2, md: 3}}}>
                <Tabs value={location.pathname} onChange={handleChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                    <Tab label={t('navigation:nav_items')} value="/app/items"/>
                    <Tab label={t('navigation:nav_packaging')} value="/app/items/packaging"/>
                </Tabs>
            </Box>

            <Routes>
                <Route index element={<Items/>}/>
                {/*<Route path="/new" element={<CreateItem/>}/>*/}
                <Route path="packaging" element={<Packagings/>}/>
            </Routes>
        </Box>
    );
}

export default ItemsMain;
